export const resolveSaturdayCredit = ({ rawCredit = 0, eligible = false, override } = {}) => {
  if (rawCredit > 0) return rawCredit;
  if (override === 'absent') return 0;
  if (override === 'present') return 1;
  if (eligible) return 1;
  return rawCredit;
};

export const hasPositiveDayCredit = (credit) => typeof credit === 'number' && credit > 0;

export default {
  resolveSaturdayCredit,
  hasPositiveDayCredit
};
